import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import {
  guardianContactUsSchema,
  INITIAL_GUARDIAN_CONTACT_US_FORM,
  type GuardianContactUsForm,
} from '@/features/guardian-profile/schemas/guardian-contact-us-schema';
import { useSessionStore } from '@/stores/session-store';

/**
 * react-hook-form instance for the Contact Us screen (validated on submit).
 * The email is prefilled from the signed-in guardian and shown read-only.
 */
export function useGuardianContactUsForm() {
  const email = useSessionStore(state => state.user?.email) ?? '';

  return useForm<GuardianContactUsForm>({
    mode: 'onSubmit',
    resolver: yupResolver(guardianContactUsSchema) as never,
    defaultValues: { ...INITIAL_GUARDIAN_CONTACT_US_FORM, email },
  });
}

export default useGuardianContactUsForm;
